import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import React, { useState, useEffect } from "react";
import { AvForm } from "availity-reactstrap-validation";
import TextField from "@material-ui/core/TextField";
import { Button, Alert, Input, FormGroup, Label, Col } from "reactstrap";
import InfoIcon from "@material-ui/icons/Info";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Credentiallist = () => {
  const [state, setState] = React.useState({
    name: "",
    description: "",
    auth_method: "",
    username: "",
    password: "",
    ssh_key: "",
    os_type: "",
    errorMessage: "",
    showPassword: false,
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleClickShowPassword = () => {
    setState({
      ...state,
      showPassword: !state.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    const NodeRSA = require("node-rsa");
    if (
      ((state.username === "Administrator" ||
        state.username === "administrator") &&
        state.os_type === "windows") ||
      ((state.username === "root" || state.username === "Root") &&
        state.os_type === "linux")
    ) {
      if (state.os_type === "windows") {
        setState({
          errorMessage:
            "Please provide the local user credentials, for the domain controller.",
        });
      } else {
        setState({
          errorMessage:
            "For security reasons root users are not allowed in Linux!",
        });
      }
    } else {
      if (/^[A-Za-z][A-Za-z0-9-_.]*$/.test(state.username)) {
        if (state.os_type === "windows") {
          const register = {
            name: state.name,
            description: state.description,
            auth_method: state.auth_method,
            username: state.username,
            password: state.password,
            ssh_key: state.ssh_key,
            os_type: state.os_type,
          };
          fetch(`${process.env.REACT_APP_API_URL}/api/credentials/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + window.localStorage.getItem("token"),
            },
            body: JSON.stringify(register),
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.name) {
                setOpen(!open);
              }
            })
            .catch((error) => {
              console.error(error);
              window.location.href = "/something_went_wrong";
            });
        } else {
          if (state.ssh_key) {
            const pemKey = state.ssh_key;
            var lines = pemKey.split("\n");
            var OpenkeyType = "";
            var EndkeyType = "";
            for (var i = 0; i < lines.length; i++) {
              if (lines[i] === "-----BEGIN RSA PUBLIC KEY-----") {
                OpenkeyType = "RSApublic";
              } else if (lines[i] === "-----BEGIN RSA PRIVATE KEY-----") {
                OpenkeyType = "RSAprivate";
              } else if (lines[i] === "-----BEGIN PUBLIC KEY-----") {
                OpenkeyType = "PUBLIC";
              } else if (lines[i] === "-----BEGIN PRIVATE KEY-----") {
                OpenkeyType = "PRIVATE";
              } else if (lines[i] === "-----BEGIN OPENSSH PRIVATE KEY-----") {
                OpenkeyType = "OPENSSHprivate";
              } else if (lines[i].match("ssh-rsa")) {
                OpenkeyType = "SSHRSA";
              } else if (lines[i] === "-----END RSA PUBLIC KEY-----") {
                EndkeyType = "RSApublic";
              } else if (lines[i] === "-----END RSA PRIVATE KEY-----") {
                EndkeyType = "RSAprivate";
              } else if (lines[i] === "-----END PUBLIC KEY-----") {
                EndkeyType = "PUBLIC";
              } else if (lines[i] === "-----END PRIVATE KEY-----") {
                EndkeyType = "PRIVATE";
              } else if (lines[i] === "-----END OPENSSH PRIVATE KEY-----") {
                EndkeyType = "OPENSSHprivate";
              }
            }
            if (
              (OpenkeyType === "RSApublic" && EndkeyType == "RSApublic") ||
              (OpenkeyType === "RSAprivate" && EndkeyType == "RSAprivate") ||
              (OpenkeyType === "PUBLIC" && EndkeyType == "PUBLIC") ||
              (OpenkeyType === "PRIVATE" && EndkeyType == "PRIVATE") ||
              (OpenkeyType === "OPENSSHprivate" &&
                EndkeyType == "OPENSSHprivate") ||
              OpenkeyType === "SSHRSA"
            ) {
              const register = {
                name: state.name,
                description: state.description,
                auth_method: state.auth_method,
                username: state.username,
                password: state.password,
                ssh_key: state.ssh_key,
                os_type: state.os_type,
              };
              fetch(`${process.env.REACT_APP_API_URL}/api/credentials/`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer " + window.localStorage.getItem("token"),
                },
                body: JSON.stringify(register),
              })
                .then((response) => response.json())
                .then((data) => {
                  if (data.name) {
                    setOpen(!open);
                  }
                })
                .catch((error) => {
                  console.error(error);
                  window.location.href = "/something_went_wrong";
                });
            } else {
              setState({
                errorMessage: "Invalid key, Please enter the valid pem key.",
              });
            }
          } else {
            const register = {
              name: state.name,
              description: state.description,
              auth_method: state.auth_method,
              username: state.username,
              password: state.password,
              ssh_key: state.ssh_key,
              os_type: state.os_type,
            };
            fetch(`${process.env.REACT_APP_API_URL}/api/credentials/`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + window.localStorage.getItem("token"),
              },
              body: JSON.stringify(register),
            })
              .then((response) => response.json())
              .then((data) => {
                if (data.name) {
                  setOpen(!open);
                }
              })
              .catch((error) => {
                console.error(error);
                window.location.href = "/something_went_wrong";
              });
          }
        }
      } else {
        setState({
          errorMessage:
            "For security reasons special chars are not allowed in username!",
        });
      }
    }
  };

  const [open, setOpen] = useState(false);
  const [focusAfterClose] = useState(true);
  const toggle = () => setOpen(!open);

  return (
    <>
      <Dialog
        PaperProps={{
          sx: {
            width: "100%",
          },
        }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={focusAfterClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "810",
            color: "rgb(48, 68, 115)",
            fontFamily: "sans-serif",
            lineHeight: "4.5rem",
          }}
        >
          Create Credential
        </h2>
        <DialogContent>
          <div>
            {state.errorMessage && (
              <Alert color="danger"> {state.errorMessage} </Alert>
            )}
          </div>
          <AvForm role="form">
            <Label htmlFor="name">
              <strong>Name</strong>
            </Label>

            <TextField
              fullWidth
              type="text"
              id="name"
              className="form-control"
              value={state.name}
              onChange={handleChange}
              variant="outlined"
              size="small"
              placeholder="Enter Your credential name here"
            />
            <br />
            <br />

            <Label htmlFor="description">
              <strong>Description</strong>
            </Label>

            <TextField
              fullWidth
              type="text"
              id="description"
              className="form-control"
              value={state.description}
              onChange={handleChange}
              variant="outlined"
              size="small"
              placeholder="Enter the description"
            />
            <br />
            <br />
            <Label htmlFor="os_type">
              <strong>OS type</strong>
            </Label>
            <TextField
              fullWidth
              type="text"
              id="os_type"
              className="form-control"
              variant="outlined"
              size="small"
              value={state.os_type}
              onChange={handleChange}
              select
              SelectProps={{ native: true }}
            >
              {" "}
              <option>-- Search to Select --</option>
              <option value="windows">Windows</option>
              <option value="linux">Linux</option>
            </TextField>
            <br />
            <br />
            <Label htmlFor="username">
              <strong>Username</strong>
            </Label>
            <IconButton
              color="white"
              size="sm"
              title="Username Requires only Alphabets, Numerals. Not special chars"
              data-toggle="collapse"
            >
              <InfoIcon fontSize="small" />
            </IconButton>
            <TextField
              fullWidth
              type="text"
              id="username"
              className="form-control"
              value={state.username}
              onChange={handleChange}
              variant="outlined"
              size="small"
              placeholder="Enter the username"
            />
            {state.os_type === "windows" ? (
              <p style={{ marginLeft: "7px" }} align="left">
                <h5>
                  <strong>Hint:</strong> don't use Administrator User
                </h5>
              </p>
            ) : state.os_type === "linux" ? (
              <p style={{ marginLeft: "7px" }} align="left">
                <h5>
                  <strong>Hint:</strong> don't use Root User
                </h5>
              </p>
            ) : (
              ""
            )}
            <br />
            <br />
            <Label htmlFor="auth_method">
              <strong>Auth_Method</strong>
            </Label>
            <TextField
              fullWidth
              type="text"
              id="auth_method"
              className="form-control"
              value={state.auth_method}
              onChange={handleChange}
              variant="outlined"
              size="small"
              placeholder="Authentication Method"
              select
              SelectProps={{ native: true }}
            >
              {" "}
              {state.os_type === "linux" ? (
                <React.Fragment>
                  <option>-- Select Authentication Method --</option>
                  <option value="password">PasswordAuthentication</option>
                  <option value="sshkey">KeyAuthentication</option>{" "}
                </React.Fragment>
              ) : state.os_type === "windows" ? (
                <React.Fragment>
                  <option value="password">PasswordAuthentication</option>
                </React.Fragment>
              ) : (
                ""
              )}
            </TextField>
            <br />
            <br />
            {state.auth_method === "password" || state.os_type === "windows" ? (
              <FormGroup>
                <Label htmlFor="password">
                  <strong>Password</strong>
                </Label>

                <OutlinedInput
                  fullWidth
                  size="small"
                  placeholder="Enter the password ..."
                  type={state.showPassword ? "text" : "password"}
                  autoComplete="new-password"
                  name="password"
                  id="password"
                  className="form-control"
                  value={state.password}
                  onChange={handleChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {state.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormGroup>
            ) : (
              ""
            )}
            {state.auth_method === "sshkey" ? (
              <React.Fragment>
                <FormGroup>
                  <Label htmlFor="ssh_key">
                    <strong>SSH_Key</strong>
                  </Label>
                  <TextField
                    style={{ marginLeft: "32px", width: "86%" }}
                    multiline
                    rows={3}
                    htmlFor="ssh_key"
                    placeholder="Enter the ssh key ..."
                    type="text"
                    autoComplete="new-ssh_key"
                    name="ssh_key"
                    variant="outlined"
                    size="small"
                    id="ssh_key"
                    className="form-control"
                    value={state.ssh_key}
                    onChange={handleChange}
                  />
                </FormGroup>
                <p style={{ marginLeft: "90px" }} align="left">
                  <h5>
                    <strong>Hint:</strong> Ensure you are giving the correct PEM
                    key format
                  </h5>
                </p>
              </React.Fragment>
            ) : (
              ""
            )}
          </AvForm>
        </DialogContent>
        <DialogActions>
          <Button
            className="bg-blueGray-200 text-white active:bg-blueGray-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={toggle}
          >
            Cancel
          </Button>
          <Button
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="submit"
            onClick={handleSubmitClick}
          >
            Create&nbsp;
            {state.submitted && <i className="fas fa-sync fa-spin"></i>}
          </Button>
        </DialogActions>
      </Dialog>

      <Col md={2}>
        <FormGroup>
          <Button
            variant="contained"
            style={{ border: "aliceblue", background: "lightgrey" }}
            color="blue"
            onClick={toggle}
          >
            +Add
          </Button>
        </FormGroup>
      </Col>
    </>
  );
};
export default Credentiallist;
